import React from "react";
import PropTypes from "prop-types";
import styles from "./Steps.module.css";

// icons
import { ReactComponent as TickIcon } from "./../../assets/svg/tick.svg";
import { ReactComponent as CartIcon } from "./../../assets/svg/step-basket.svg";
import { ReactComponent as ShippingIcon } from "./../../assets/svg/step-location.svg";
import { ReactComponent as CheckoutIcon } from "./../../assets/svg/step-checkout.svg";
import { useTranslation } from "react-i18next";
import { useLangNavigate } from "../../hooks/useLangNavigate";

const stepsList = [
  {
    step: 1,
    name: "cart",
    href: "/cart",
    icon: CartIcon,
  },
  {
    step: 2,
    name: "shipping",
    icon: ShippingIcon,
    href: null,
  },
  {
    step: 3,
    name: "checkout",
    icon: CheckoutIcon,
    href: null,
  },
];
const Steps = (props) => {
  const { t } = useTranslation();
  const navigate = useLangNavigate();
  const { step = 1, open, hasShadow = false } = props;

  const itemClick = (href, itemStep) => {
    if (typeof href === "string") {
      if (itemStep < step) {
        navigate(href);
      }
    }
  };

  return (
    <div
      className={`${styles.StepsContainer} ${open ? styles.Open : ""} ${
        hasShadow ? styles.Shadow : ""
      }`}
    >
      <div className={styles.Steps}>
        {stepsList.map((stepItem, stepItemIndex) => {
          const Icon = stepItem.icon;
          return (
            <>
              {stepItemIndex > 0 && (
                <div
                  className={`${styles.BackLine} ${
                    step - 1 >= stepItemIndex ? styles.Active : ""
                  }`}
                />
              )}
              <div
                onClick={() => itemClick(stepItem.href, stepItem.step)}
                className={`${styles.StepItem} ${
                  stepItemIndex + 1 < parseInt(step) ? styles.Done : ""
                }  ${
                  stepItemIndex + 1 === parseInt(step) ? styles.Active : ""
                } ${stepItem.step < step ? styles.Cursor : ""}`}
              >
                <div className={styles.StepItemIndex}>
                  {stepItemIndex + 1 >= parseInt(step) && stepItemIndex + 1}
                  {stepItemIndex + 1 < parseInt(step) && (
                    <TickIcon className={styles.TickIcon} />
                  )}
                </div>
                <Icon
                  className={`${styles.StepItemIcon} ${
                    step - 1 === stepItemIndex ? styles.Active : ""
                  } ${stepItem.className}`}
                />
                <span className={styles.StepItemName}>
                  {t(`cart.${stepItem.name}`)}
                </span>
              </div>
            </>
          );
        })}
      </div>
    </div>
  );
};

Steps.propTypes = {
  data: PropTypes.array.isRequired,
  step: PropTypes.number || PropTypes.string,
  className: PropTypes.string,
};

export default Steps;
